// Utility functions for handling JWT tokens

export const isValidJwtFormat = (token: string | null): boolean => {
  if (!token || typeof token !== 'string') {
    return false;
  }
  
  // JWT tokens have 3 parts separated by dots
  const parts = token.split('.');
  return parts.length === 3 && parts.every(part => part.length > 0);
};

export const clearInvalidTokens = (): void => {
  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  
  if (!isValidJwtFormat(accessToken)) {
    console.warn('Invalid access token format detected, clearing...');
    localStorage.removeItem('accessToken');
  }
  
  if (!isValidJwtFormat(refreshToken)) {
    console.warn('Invalid refresh token format detected, clearing...');
    localStorage.removeItem('refreshToken');
  }
};

export const validateAndStoreTokens = (accessToken: string, refreshToken?: string): void => {
  if (!isValidJwtFormat(accessToken)) {
    throw new Error('Invalid access token format received from server');
  }
  
  localStorage.setItem('accessToken', accessToken);
  
  if (refreshToken) {
    if (!isValidJwtFormat(refreshToken)) {
      throw new Error('Invalid refresh token format received from server');
    }
    localStorage.setItem('refreshToken', refreshToken);
  } else {
    // Clear any existing refresh token if none provided
    localStorage.removeItem('refreshToken');
  }
};

export const getStoredTokens = (): { accessToken: string | null; refreshToken: string | null } => {
  return {
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken')
  };
};

export const clearAllTokens = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};